module.exports = __webpack_public_path__ + "img/elf_2.835cc51f.png";